<template>
  <div class="feature-faqs-block observed" :class="{ hidden: !visible }">
    <h2 class="feature-faqs-block-title">{{ title }}</h2>
    <div class="feature-faqs-block-list-item" v-for="(c, i) in faqsList" :key="i">
      <h3 class="feature-faqs-block-question">{{ c.title }}</h3>
      <text-wysiwyg class="features" :content="c.text" />
    </div>
    <div v-if="buttonUrl" class="button-box">
      <a v-if="!getInternalLink(buttonUrl)" :href="buttonUrl" class="cta cta-blue"><span>{{
        buttonText }}</span></a>
      <router-link v-else :to="buttonUrl" class="cta cta-blue"><span>{{ buttonText }}</span></router-link>
    </div>
  </div>
</template>

<script>
import SectionMixin from '@/mixins/sectionMixin'
import TextWysiwyg from '@/components/global/text-wysiwyg'

export default {
  name: 'feature-faqs',
  mixins: [SectionMixin],
  components: {
    'text-wysiwyg': TextWysiwyg,
  },
  props: {
    title: String,
    faqsList: Array,
    buttonText: String,
    buttonUrl: String
  },
  data: () => {
    return {
      visible: false,
    }
  },
  mounted() {

  },
  methods: {
    show() {
      this.visible = true
    },
  }
}
</script>

<style lang="less">
@import "../../../styles/vars.less";

.feature-faqs-block {
  padding: 140px 140px 133px;
  background-color: @grey;
  transition: transform 1s @custom-ease-1, opacity 1s @custom-ease-1;

  &.hidden {
    opacity: 0;
  }

  .feature-faqs-block-title {
    font-family: @bold;
    color: @blue-dark;
    font-size: 2.75rem;
    margin-bottom: 56px;
    text-align: center;
  }

  .feature-faqs-block-list-item {
    border-bottom: 1px solid @black;
    padding-bottom: 32px;
    margin-bottom: 40px;
  }

  .feature-faqs-block-question {
    color: @blue-mid;
    font-family: @bold;
    font-size: 1.125rem;
    margin-bottom: 16px;
  }

  .text-wysiwyg {
    max-width: initial;

    .markdown-body {
      color: @blue-mid;
    }
  }

  .button-box {
    position: relative;
    max-width: fit-content;
    justify-self: center;
    z-index: 2;
  }
}

@media screen and (max-width: @tablet) {
  .feature-faqs-block {
    padding: 120px 28px;

    .feature-faqs-block-title {
      font-size: 2.25rem;
    }

    .button-box {
      margin-top: 94px;
    }
  }
}
</style>